module.exports = __webpack_public_path__ + "img/guide-01.1d1a355b.png";